import React from 'react';
import Text from '../../../components/Text';
import Button from '../../../components/Button';

interface DeletePictureModalProps {
    branchName: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DeletePictureModal: React.FC<DeletePictureModalProps> = ({
    branchName,
    onConfirm,
    onCancel,
}) => {
    return (
        <div>
            <Text classes={'zr-mb-4'}>
                {`Bild von „${branchName}“ wirklich entfernen?`}
            </Text>
            <div className={'zr-d-flex zr-gap-2'}>
                <Button hierarchy="primary" text="Entfernen" fn={onConfirm} />
                <Button hierarchy="secondary" text="Abbrechen" fn={onCancel} />
            </div>
        </div>
    );
};
